import React, { useEffect, useState } from "react";
import {
    Table,
    Button,
    Modal,
    Form,
    Input,
    Select,
    message,
    Popconfirm,
} from "antd";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import API_BASE from "../config/api";

const { Option } = Select;

const AdminModesPage = () => {
    const [merchantList, setMerchantList] = useState([]);
    const [selectedMerchant, setSelectedMerchant] = useState(null);
    const [modeList, setModeList] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [editingMode, setEditingMode] = useState(null);
    const [loading, setLoading] = useState(false);
const [adminModalVisible, setAdminModalVisible] = useState(false);

    const [form] = Form.useForm();
    const navigate = useNavigate();
    const location = useLocation();

    const comebackCustomerId = location.state?.customer_id || null;

    const fetchMerchants = async () => {
        try {
            const { data } = await axios.get(`${API_BASE}/fetchMerchantForMode`);
            const list = data?.data || [];
            setMerchantList(list);

            if (comebackCustomerId) {
                const merchant = list.find(
                    (m) => m.customer_id === comebackCustomerId
                );
                if (merchant) setSelectedMerchant(merchant);
            }
        } catch (err) {
            console.error(err);
            message.error("Failed to fetch merchants");
        }
    };

    const fetchModes = async () => {
        if (!selectedMerchant) return;

        try {
            setLoading(true);
            const { data } = await axios.get(`${API_BASE}/getModes`, {
                params: { customer_id: selectedMerchant.customer_id },
            });
            setModeList(data?.data || []);
        } catch (err) {
            console.error(err);
            message.error("Failed to fetch modes");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (_id) => {
        try {
            await axios.post(`${API_BASE}/deleteMode`, { _id });
            message.success("Mode deleted");
            fetchModes();
        } catch (err) {
            console.error(err);
            message.error("Delete failed");
        }
    };

    const handleAddEditMode = async (values) => {
        if (!selectedMerchant)
            return message.error("Select a merchant first!");

        try {
            if (editingMode) {
                await axios.post(`${API_BASE}/updateMode`, {
                    _id: editingMode._id,
                    customerId: selectedMerchant.customer_id,
                    ...values,
                });
                message.success("Mode updated");
            } else {
                const { data } = await axios.post(`${API_BASE}/addMode`, {
                    customerId: selectedMerchant.customer_id,
                    ...values,
                });

                message.success("Mode added");

                const newModeId = data?.data?._id;
                if (newModeId)
                    navigate(`/admin/promo-ads/${newModeId}`, {
                        state: { customer_id: selectedMerchant.customer_id },
                    });
            }

            setModalVisible(false);
            form.resetFields();
            setEditingMode(null);
            fetchModes();
        } catch (err) {
            console.error(err);
            message.error("Save failed");
        }
    };

    useEffect(() => {
        fetchMerchants();
    }, []);

    useEffect(() => {
        fetchModes();
    }, [selectedMerchant]);

    return (
        <div className="modSpace">
            <h2>Mode Manager</h2>

            <div className="relContnet">

            <Select
                showSearch
                virtual={false}
                style={{ width: 300, marginBottom: 20 }}
                placeholder="Select Merchant"
                value={selectedMerchant?.customer_id || null}
                onChange={(customer_id) => {
                    const merchant = merchantList.find(
                        (m) => m.customer_id === customer_id
                    );
                    setSelectedMerchant(merchant);
                }}
                filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                }
                options={Array.from(
                    new Map(
                        merchantList.map((m) => [m.customer_id, { label: m.full_name, value: m.customer_id }])
                    ).values()
                )}
            />



            {selectedMerchant && (
                <div
                    className="boxDivs"
                >
                    <h3>Selected Merchant</h3>
                    <p>
                        <b>Name:</b> {selectedMerchant.name}
                    </p>
                    <p>
                        <b>Mobile:</b> {selectedMerchant.mobile || "N/A"}
                    </p>
                    <p>
                        <b>Customer ID:</b> {selectedMerchant.customer_id}
                    </p>
                </div>
            )}

            <Button
                type="primary"
                className="adMode-btn"
                onClick={() => {
                    setEditingMode(null);
                    form.resetFields();
                    form.setFieldsValue({ modeName: "Mode 1" }); // ✅ Set default value
                    setModalVisible(true);
                }}
            >
                Add Mode
            </Button>
            </div>


            <Table
                style={{ marginTop: 20 }}
                loading={loading}
                rowKey="_id"
                dataSource={modeList}
                columns={[
                    {
                        title: "Mode Name",
                        dataIndex: "modeName",
                    },
                    {
                        title: "Actions",
                        render: (_, record) => (
                            <>
                              
                                <Button
                                    type="link"
                                    onClick={() =>
                                        navigate(`/admin/promo-ads/${record._id}`, {
                                            state: {
                                                customer_id: selectedMerchant.customer_id,
                                            },
                                        })
                                    }
                                >
                                   Update
                                </Button>

                                      <Button
                                    type="link"
                                    onClick={() => {
                                        setEditingMode(record);
                                        form.setFieldsValue(record);
                                        setModalVisible(true);
                                    }}
                                >
                                 Rename
                                </Button>

                                <Popconfirm
                                    title="Delete this mode?"
                                    onConfirm={() => handleDelete(record._id)}
                                >
                                    <Button type="link" danger>
                                        Delete
                                    </Button>
                                </Popconfirm>
                            </>
                        ),
                    },
                ]}
            />

            <Modal
                title={editingMode ? "Edit Mode" : "Add Mode"}
                open={modalVisible}
                onCancel={() => {
                    setModalVisible(false);
                    form.resetFields();
                }}
                onOk={() => form.submit()}
            >
                <Form form={form} layout="vertical" onFinish={handleAddEditMode}>
                    <Form.Item
                        name="modeName"
                        label="Mode Name"
                        rules={[{ required: true }]}
                    >
                        <Input placeholder="Enter mode name" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default AdminModesPage;
